import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { HostListener } from '@angular/core';
import { environment } from 'src/environments/environment';
import { AuthService } from '../../pages/user-panel/auth.service';
import { Subscription } from 'rxjs';
import { ThumbnailPipe } from '../../../utils/pipe/thumbnail.pipe'; 


@Component({
  selector: 'app-panel-layout',
  templateUrl: './panel-layout.component.html',
  styleUrls: ['./panel-layout.component.scss'],
  providers: [ThumbnailPipe]

})
export class PanelLayoutComponent {
  isCollapsed = false; // Estado inicial de la barra lateral
  isDropdownOpen = false;
  currentUrl: string = '';
  data: any = {}
  private baseUrl = environment.apiUrl;

  token: string | null = null;
  private tokenSubscription: Subscription;


  constructor(private router: Router,  private authService:AuthService, private thumbnailPipe:ThumbnailPipe) {}

  toggleSidebar() {
    this.isCollapsed = !this.isCollapsed;
  }

  ngOnInit(): void {
    this.router.events.subscribe(() => {
      this.currentUrl = this.router.url; 
    });

    this.tokenSubscription = this.authService.token$.subscribe((token) => {
      this.data={
        "imageUrl" : this.thumbnailPipe.transform(this.baseUrl+this.authService.getPhoto()),
        "names" : this.authService.getUserName()+" "+this.authService.getUserSurname()
       }
    });
  }

  ngOnDestroy(): void {
    if (this.tokenSubscription) {
      this.tokenSubscription.unsubscribe();
    }
  }



  @HostListener('window:resize', ['$event'])
  onResize(event: any) {
    if (window.innerWidth < 768) {
      this.isCollapsed = true; 
    }
    if (window.innerWidth > 768) {
      this.isCollapsed = false; 
    }
  }
  toggleDropdown(): void {
    this.isDropdownOpen = !this.isDropdownOpen;
  }

  closeDropdown(): void {
    this.isDropdownOpen = false;
  }

}
